import React from 'react';

import {CompetitionsSliderWidgetProps} from "../models/competitions-slider-widget.props";
import {CompetitionsSliderWidgetDropdown} from "./dropdown/competitions-slider-widget.dropdown";
import {APP} from "../../../core/app/consts";
import {Sponsorship} from "../../../core/components/sponsorship/sponsorship";
import {useBookieClick} from "../../../infrastructure/hooks/useBookieClick";

export class CompetitionsSliderWidgetTopBarProps extends CompetitionsSliderWidgetProps {
}

export const CompetitionsSliderWidgetTopBar = (({controller}: CompetitionsSliderWidgetTopBarProps) => {
  const {state} = controller;
  const {
    sponsorshipBookmaker,
    selectedCompetition,
    appSettings,
    currentLinkModel,
    sponsoredBookmakerVisible,
    shouldRenderPoweredBy,
    appState
  } = state;

  const betsImpressionParams = {
    bookieId: sponsorshipBookmaker?.id,
    bookieName: sponsorshipBookmaker?.name,
    sportTypeId: selectedCompetition?.sport.id
  }

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    urlLink: appSettings.publisherSettings.bookmakerUrl || sponsorshipBookmaker?.link,
    currentLinkModelName: currentLinkModel?.name,
    bookieId: sponsorshipBookmaker?.id,
    bookieName: sponsorshipBookmaker?.name,
    widget: APP.GOOGLE_ANALYTICS.SOURCES.slider,
    hasOdds: !!sponsorshipBookmaker,
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.main,
    buttonType: APP.ANALYTICS.BUTTON_TYPES_MAPPER.bookie,
    source: APP.ANALYTICS.SOURCES.slider
  });

  const sponsorshipProps = {
    bookmaker: sponsoredBookmakerVisible && sponsorshipBookmaker,
    controller,
    i18n: controller.state.terms,
    clickable: Boolean(appSettings.publisherSettings.bookmakerUrl || sponsorshipBookmaker?.link),
    betsImpressionParams,
    bookieHrefModel,
    onClick: () => onBookieClick(),
    shouldRenderPoweredBy,
    poweredByText: appState.poweredByModel.text,
    poweredByLink: appState.poweredByModel.link
  }

  return (
    <div className={'competitions-slider-widget-top-bar-container'}>
      {
        controller.state.shouldRenderTopDropdown &&
        <CompetitionsSliderWidgetDropdown controller={controller} selectedCompetitionId={controller.state.selectedCompetitionId}/>
      }
      <Sponsorship {...sponsorshipProps}/>
    </div>
  )
});
